<template>
  <Modal v-model="showModal"
    scrollable
    :mask="true"
    :mask-closable="false"
    @on-cancel="closeModal"
    class="user-new"
    title="注册新用户">
    <RadioGroup v-model="type" type="button" button-style="solid">
      <Radio label="guarantorUser">保证人</Radio>
      <Radio label="contractorUser">总承包商</Radio>
    </RadioGroup>
    <div class="padding-top-20"></div>
    <Form ref="newGuarantorForm" :model="userModel"
      v-show="type==='guarantorUser'"
      :rules="modelValidate"
      label-position="left"
      :label-width="120">
      <FormItem label="姓名" prop="displayName">
        <Input v-model="userModel.displayName" placeholder="输入姓名" />
      </FormItem>
      <FormItem label="登录用户名" prop="loginName">
        <Input v-model="userModel.loginName" placeholder="输入登录用户名" />
      </FormItem>
      <FormItem label="登录密码" prop="password">
        <Input v-model="userModel.password" type="password" placeholder="输入登录密码" />
      </FormItem>
      <FormItem label="重复登录密码" prop="rePassword">
        <Input v-model="userModel.rePassword" type="password" placeholder="重复输入登录密码" />
      </FormItem>
      <FormItem label="手机号" prop="mobile">
        <Input v-model="userModel.mobile" placeholder="输入手机号" />
      </FormItem>
    </Form>
    <Form ref="newContractorForm" :model="userContractorModel"
      v-show="type==='contractorUser'"
      :rules="modelContractorValidate"
      label-position="left"
      :label-width="120">
      <FormItem label="公司名称" prop="companyName">
        <Input v-model="userContractorModel.companyName" placeholder="输入公司名称" />
      </FormItem>
      <FormItem label="信用代码证号" prop="businessLicense">
        <Input v-model="userContractorModel.businessLicense" placeholder="输入公司信用代码证号" />
      </FormItem>
      <FormItem label="法人" prop="legalPersonName">
        <Input v-model="userContractorModel.legalPersonName" placeholder="输入法人姓名" />
      </FormItem>
      <FormItem label="姓名" prop="displayName">
        <Input v-model="userContractorModel.displayName" placeholder="输入姓名" />
      </FormItem>
      <FormItem label="登录用户名" prop="loginName">
        <Input v-model="userContractorModel.loginName" placeholder="输入登录用户名" />
      </FormItem>
      <FormItem label="登录密码" prop="password">
        <Input v-model="userContractorModel.password" type="password" placeholder="输入登录密码" />
      </FormItem>
      <FormItem label="重复登录密码" prop="rePassword">
        <Input v-model="userContractorModel.rePassword" type="password" placeholder="重复输入登录密码" />
      </FormItem>
      <FormItem label="手机号" prop="mobile">
        <Input v-model="userContractorModel.mobile" placeholder="输入手机号" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="primary" @click="submit" v-if="type==='guarantorUser'">提交</Button>
      <Button type="primary" @click="submitContractor" v-if="type==='contractorUser'">提交</Button>
      <Button @click="closeModal">取消</Button>
    </div>
  </Modal>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'user-new',
  props: {
    show: Boolean
  },
  data () {
    const validateRepassword = (rule, value, callback) => {
      if (this.userModel.password && value !== this.userModel.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        if (callback) {
          callback()
        }
      }
    }
    return {
      showModal: false,
      loading: false,
      type: 'guarantorUser', // guarantorUser-保证人，contractorUser-承包商
      userModel: {
        companyName: null,
        businessLicense: null,
        legalPersonName: null,
        contact: null,
        contactTel: null,
        displayName: null,
        password: null,
        rePassword: null,
        passwordMd5: null,
        gender: 1,
        loginName: null,
        enabled: true,
        mobile: null,
        email: null,
        type: 3,
        certCn: null,
        roleId: null
      },
      modelValidate: {
        displayName: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        loginName: [
          { required: true, message: '请填写用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'blur' }
        ],
        rePassword: [
          { validator: validateRepassword, trigger: 'blur' }
        ]
      },
      userContractorModel: {
        companyName: null,
        businessLicense: null,
        legalPersonName: null,
        contact: null,
        contactTel: null,
        address: null,
        displayName: null,
        password: null,
        rePassword: null,
        passwordMd5: null,
        gender: 1,
        loginName: null,
        enabled: true,
        mobile: null,
        email: null,
        type: 3,
        certCn: null,
        roleId: null
      },
      modelContractorValidate: {
        companyName: [
          { required: true, message: '请填写公司名称', trigger: 'blur' }
        ],
        businessLicense: [
          { required: true, message: '请填写企业信用代码证号', trigger: 'blur' }
        ],
        legalPersonName: [
          { required: true, message: '请填写法人姓名', trigger: 'blur' }
        ],
        displayName: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        loginName: [
          { required: true, message: '请填写用户名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请填写手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'blur' }
        ],
        rePassword: [
          { validator: validateRepassword, trigger: 'blur' }
        ]
      },
      roles: []
    }
  },
  watch: {
    show: function (val) {
      this.showModal = val
    },
    'userContractorModel.displayName': function (val) {
      this.userContractorModel.contact = val
    },
    'userContractorModel.mobile': function (val) {
      this.userContractorModel.contactTel = val
    }
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    closeModal () {
      this.showModal = false
      this.$emit('on-close')
    },
    async submit () {
      this.$refs.newGuarantorForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          this.userModel.passwordMd5 = this.$md5(this.userModel.password)
          await Api.Auth(this).register(this.userModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.userModel= {
                displayName: null,
                password: null,
                rePassword: null,
                passwordMd5: null,
                gender: 1,
                loginName: null,
                enabled: true,
                mobile: null,
                email: null,
                type: 3,
                certCn: null,
                roleId: null
              }
              this.loading = false
              this.$Spin.hide()
              this.closeModal()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    },
    async submitContractor () {
      this.$refs.newContractorForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          this.userContractorModel.passwordMd5 = this.$md5(this.userContractorModel.password)
          await Api.Auth(this).registerContractorUser(this.userContractorModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.userContractorModel= {
                companyName: null,
                businessLicense: null,
                legalPersonName: null,
                contact: null,
                contactTel: null,
                address: null,
                displayName: null,
                password: null,
                rePassword: null,
                passwordMd5: null,
                gender: 1,
                loginName: null,
                enabled: true,
                mobile: null,
                email: null,
                type: 3,
                certCn: null,
                roleId: null
              }
              this.loading = false
              this.$Spin.hide()
              this.closeModal()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    },
    changeUserType (cur) {
      if (cur && this.roles && this.roles instanceof Array) {
        this.roles.forEach((r) => {
          if (r.type !== cur) {
            r.disabled = true
          } else {
            r.disabled = false
          }
        })
      }
    }
  }
}
</script>

<style lang="less">
</style>
